export const INDUSTRIES = [
  {
    slug: "cement",
    name: "Cement",
    image: "/images/cement/c13.jpg",
    challenges: ["Extreme abrasion in chutes, hoppers and crushers", "Duct and conveyor wear", "Costly unplanned kiln-line stoppages"],
    solutions: ["CCO & Hardox wear liners", "Chute, hopper and bin fabrication", "Hardfacing and crusher-component reconditioning"],
    applications: ["Chutes & hoppers", "Crushers", "Conveyors & transfer points", "Bins & silos", "Ducts"],
  },
  {
    slug: "mining-quarry",
    name: "Mining & Quarry",
    image: "/images/cement/c19.jpg",
    challenges: ["Bucket and GET wear", "Impact + abrasion in crushing circuits", "Remote-site repair logistics"],
    solutions: ["Excavator bucket reconditioning & hardfacing", "Crusher liners and wear plates", "Heavy equipment structural repair"],
    applications: ["Excavator & loader buckets", "Crusher components", "Chutes, hoppers & liners", "Haulage equipment repair"],
  },
  {
    slug: "steel",
    name: "Steel",
    image: "/images/steel/s50.jpg",
    challenges: ["High-temperature wear", "Heavy structural repair", "Shutdown-window pressure"],
    solutions: ["Fabricated components & structural steel", "Wear protection and hardfacing", "Equipment repair during planned stops"],
    applications: ["Material handling steelwork", "Wear plates & liners", "Equipment structures", "Maintenance fabrication"],
  },
  {
    slug: "concrete-block",
    name: "Concrete & Block",
    image: "/images/concrete/b29.jpg",
    challenges: ["Mixer and hopper abrasion", "Material leakage and buildup", "Structural fatigue on aging plants"],
    solutions: ["Brand-compatible mixer wear parts", "Wear liners for batching plants", "Plant repair and steelwork upgrades"],
    applications: ["Batching plant mixers", "Silos & conveyors", "Block-plant steelwork", "Aggregate hoppers"],
  },
  {
    slug: "oil-gas",
    name: "Oil & Gas",
    image: "/images/steel/s23.jpg",
    challenges: ["Specification-driven fabrication", "Documentation and traceability", "Site-condition constraints"],
    solutions: ["Storage tanks and associated steelwork", "Pipe supports and structures", "Fabrication to project specification"],
    applications: ["Diesel & water tanks", "Pipe racks & supports", "Platforms & walkways", "Site fabrication support"],
  },
  {
    slug: "power",
    name: "Power",
    image: "/images/cement/c10.jpg",
    challenges: ["Outage-driven maintenance windows", "Material handling wear", "Custom one-off components"],
    solutions: ["Shutdown fabrication support", "Wear parts for fuel & ash handling", "Custom component manufacture"],
    applications: ["Conveyor systems", "Hoppers & chutes", "Structural repairs", "Maintenance steelwork"],
  },
  {
    slug: "manufacturing",
    name: "Manufacturing",
    image: "/images/steel/s41.jpg",
    challenges: ["Custom jigs, frames and guards", "Equipment modification", "Fast turnaround on one-off parts"],
    solutions: ["Custom fabrication to drawing", "Machine guards, frames & brackets", "Equipment repair and modification"],
    applications: ["Production-line steelwork", "Platforms & access", "Custom components", "Equipment supports"],
  },
  {
    slug: "infrastructure",
    name: "Infrastructure",
    image: "/images/steel/s22.jpg",
    challenges: ["Project-scale structural steel", "Schedule-critical delivery", "Site-specific dimensions"],
    solutions: ["Structural steel fabrication", "Tanks and site facilities steelwork", "Project-based fabrication packages"],
    applications: ["Structural frames", "Brackets & supports", "Site tanks", "Temporary works steel"],
  },
  {
    slug: "industrial-contractors",
    name: "Industrial Contractors",
    image: "/images/steel/s58.jpg",
    challenges: ["Reliable fabrication subcontractor", "Consistent quality across packages", "Schedule alignment with main works"],
    solutions: ["Subcontract fabrication packages", "Wear parts supply", "Repair and reconditioning support"],
    applications: ["Fabricated packages", "Steel supply & fabrication", "Wear components", "Maintenance scopes"],
  },
  {
    slug: "epc-maintenance",
    name: "EPC & Maintenance Contractors",
    image: "/images/cement/c17.jpg",
    challenges: ["Drawing-driven scopes with tight tolerances", "Multi-package coordination", "Documentation requirements"],
    solutions: ["Fabrication to EPC drawings", "Shutdown and turnaround support", "Engineered wear and repair solutions"],
    applications: ["EPC fabrication packages", "Turnaround components", "Wear-part programs", "Site repair scopes"],
  },
];
